import {
    GetRoleList,
    GetRoleMenuByRoleId,
    GetEmployByRoleId,
    UpdateRoleEmploy,
    DelRole,
    AddRole,
    UpdateRole
} from '@api/adminApi';
import {
    GetEmployList
} from '@api/commonApi';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

module.exports = {
    created() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            this.sysSid = user.Sid || '';
            this.sysSession = user.Session || '';

        }
        this.roleList();
    },
    data() {
        return {
            btnLoading: false,
            sysSid: "",
            sysSession: "",
            IsEidt: false,
            RoleId: "",
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中列
            roleDialog: false, //权限弹出层
            roleControlDialog: false, //人员弹出层
            loadingTable: false, //table加载
            RoleListNum: "", //服务端给予的权限长度，用于全选
            getRoleList: [], //table列表
            addRoleForm: {
                name: '',
                type: [],
                checked: false,
                title: '',
            }, //增加角色         
            defaultProps: {
                children: 'EachList',
                label: 'MenuName'
            },
            roleControlForm: {
                allData: [],
                roleName: '',
                searchName: '',
                state: '',
                timeout: null,
                dynamicTags: [], //当前包含人员
                roleId: '', //当前id  
            },
        }
    },
    methods: {
        //列表
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.roleList();
        }, //分页选定行
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.roleList();
        }, //分页监听页面
        selsChange: function (sels) {
            this.sels = sels;
        },
        roleList: function () {
            this.getRoleList = [];
            var GetAdminListParams = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            };
            GetRoleList(GetAdminListParams).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    this.totalSize = res.data.Cnt;
                    this.getRoleList = res.data.Data;
                }
            })
        },
        //提交表单
        getChecked(param) {

            if (param == 0) {
                var List = this.$refs.tree.getCheckedNodes();
            } else {
                var List = this.$refs.editTree.getCheckedNodes();
            }
            var nodeList = [];
            let len = this.addRoleForm.type.length;
            let len2 = List.length;
            for (var j = 0; j < len2; j++) {
                var listNode = {};
                listNode.MenuId = List[j].MenuId;
                listNode.MenuName = List[j].MenuName;
                nodeList.push(listNode)
                let len3 = nodeList.length;
                // if (List[j].ParentId > 0) {
                //     for (var m = 0; m < len; m++) {
                //         if (List[j].ParentId == this.addRoleForm.type[m].MenuId) {
                //             let myparent = {};
                //             myparent.MenuId = this.addRoleForm.type[m].MenuId;
                //             myparent.MenuName = this.addRoleForm.type[m].MenuName;
                //             for (var w = 0; w < nodeList.length; w++) {
                //                 if (nodeList[w].MenuId != myparent.MenuId) {
                //                     nodeList.push(myparent)
                //                 }
                //             }
                //         }
                //     }
                // }
            }

            var hash = {};
            nodeList = nodeList.reduce(function (item, next) {
                hash[next.MenuId] ? '' : hash[next.MenuId] = true && item.push(next);
                return item;
            }, []);
            if (this.addRoleForm.name == '') {
                this.$notify({
                    title: '错误',
                    message: '角色名称不能为空',
                    type: 'error'
                });
                return false
            }
            var params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                List: nodeList,
                RoleName: this.addRoleForm.name
            };
            if (this.addRoleForm.title == '修改权限') {
                params.RoleId = this.RoleId;
                this.btnLoading = true;
                UpdateRole(params).then(res => {
                    this.btnLoading = false;
                    util.doResult(this, res, () => {
                        this.roleList()
                        this.roleDialog = false;
                        this.$notify({
                            title: '成功',
                            message: "更新成功",
                            type: 'success'
                        });
                    });
                });
            } else {
                this.btnLoading = true;
                AddRole(params).then(res => {
                    this.btnLoading = false;
                    util.doResult(this, res, () => {
                        this.roleList()
                        this.roleDialog = false;
                        this.$notify({
                            title: '成功',
                            message: "添加成功",
                            type: 'success'
                        });
                    })

                })
            }
        },
        //新增编辑弹出框
        addRole: function (RoleId) {
            this.addRoleForm.title = RoleId == 0 ? '新增角色' : '修改权限';

            if (RoleId === 0) {
                this.addRoleForm.name = ''
            }
            this.roleDialog = true;
            var params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                RoleId: RoleId
            };
            GetRoleMenuByRoleId(params).then(res => {
                util.doResult(this, res, () => {
                    this.addRoleForm.type = res.data.Data.MenuList;
                    // 计算列表长度，用于handleCheckChange()的全选函数
                    this.RoleListNum = this.addRoleForm.type.length;
                    for (i = 0; i < this.addRoleForm.type.length; i++) {
                        if (this.addRoleForm.type[i].EachList.length > 0) {
                            this.RoleListNum += this.addRoleForm.type[i].EachList.length;
                        }
                    }
                    if (RoleId != 0) {
                        var checkedPower = [];
                        for (var i = this.addRoleForm.type.length - 1; i >= 0; i--) {
                            if (this.addRoleForm.type[i].Exist != 0) {
                                for (var j = this.addRoleForm.type[i].EachList.length - 1; j >= 0; j--) {
                                    if (this.addRoleForm.type[i].EachList[j].Exist != 0) {
                                        checkedPower.push(this.addRoleForm.type[i].EachList[j])
                                    }
                                };
                            } else {
                                for (var j = this.addRoleForm.type[i].EachList.length - 1; j >= 0; j--) {
                                    if (this.addRoleForm.type[i].EachList[j].Exist != 0) {
                                        checkedPower.push(this.addRoleForm.type[i].EachList[j])
                                    }
                                };
                            }
                        };
                        //console.log(JSON.stringify(checkedPower))           
                        this.$nextTick(function () {
                            this.$refs.tree.setCheckedNodes(checkedPower)
                        })
                    }
                });

            })
        },
        //修改权限弹出框
        handleEditPower: function (index, row) {
            this.IsEdit = true;
            this.RoleId = row.Id;
            this.addRoleForm.name = row.RoleName
            this.addRole(this.RoleId);
        },
        //编辑人员弹出框
        handleEditPerson: function (index, row) {
            this.roleControlForm.roleId = '';
            this.roleControlDialog = true;
            let RoleName = row.RoleName;
            this.roleControlForm.roleId = row.Id;
            this.roleControlForm.roleName = RoleName;
            var params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                RoleId: row.Id
            };
            GetEmployByRoleId(params).then(res => {
                util.doResult(this, res, () => {
                    this.roleControlForm.dynamicTags = res.data.Data
                });

            })
        },
        //删除
        del: function (index, row) {
            this.$confirm('此操作将永久删除此条记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var params = {
                    Ids: row.Id
                };
                DelRole(params).then(res => {
                    util.doResult(this, res, () => {
                        this.roleList();
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    });

                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //选中子集 父集节点选中 ps 代码存在冗余 
        handleCheckChange(data, checked, indeterminate) {
            // let nodesDOM = this.$refs.tree.$el.querySelectorAll('.el-tree-node'),

            //     nodesVue = [].map.call(nodesDOM, node => node.__vue__),    

            //     nodeParent = nodesVue.filter(item => item.indeterminate === true);

            // if(nodeParent.length > 0 ){
            //   nodeParent[0].node.checked = true;  
            //   nodeParent[0].node.indeterminate = false
            // } 
            //  if(!checked){
            //     this.addRoleForm.checked = false
            //  }
            let List = this.$refs.tree.getCheckedNodes();
            if (List.length == this.RoleListNum) {
                this.addRoleForm.checked = true
            } else {
                this.addRoleForm.checked = false
            }
        },
        // 全选
        checkAll(ev) {
            if (ev.target.checked) {
                this.$refs.tree.setCheckedNodes(this.addRoleForm.type)
            } else {
                this.$refs.tree.setCheckedKeys([]);
            }
        },
        querySearchAsync(queryString, cb) {
            var allData = this.roleControlForm.allData;
            var results = queryString ? allData.filter(this.createStateFilter(queryString)) : allData;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                cb(results);
            }, 1500 * Math.random());
        },
        createStateFilter(queryString) {
            return (state) => {
                return (state.value.indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelect(item) {
            var flag = 1;
            for (var i = this.roleControlForm.dynamicTags.length - 1; i >= 0; i--) {
                if (this.roleControlForm.dynamicTags[i].EmployeeId === item.Id) {
                    flag = 2
                }
            };
            this.roleControlForm.state = '';
            if (flag == 1) {
                let curval = {
                    EmployeeId: item.Id,
                    EmployeeName: item.value
                }
                this.roleControlForm.dynamicTags.push(curval)
            } else {
                this.$message({
                    showClose: true,
                    message: '这条记录已存在，请勿重复添加',
                    type: 'warning'
                });
            }
        },
        //删除人员
        handleClose(tag) {
            this.roleControlForm.dynamicTags.splice(this.roleControlForm.dynamicTags.indexOf(tag), 1);
        },
        //更新包含人员模块
        submitRoleControlForm() {
            var params = {
                RoleId: this.roleControlForm.roleId,
                List: this.roleControlForm.dynamicTags
            };
            this.btnLoading = true;
            UpdateRoleEmploy(params).then(res => {
                this.btnLoading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '提交成功',
                        type: 'success'
                    });
                    this.roleControlDialog = false;
                });
            });
        }

    },

    mounted() {
        this.roleControlForm.allData = [];
        var params = {
            Sid: this.sysSid,
            Session: this.sysSession,
            pageIndex: 1,
            pageSize: 2000,
            orderBy: this.orderBy,
            Name: ''
        };
        GetEmployList(params).then(res => {
            util.doResult(this, res, () => {});
            if (res.data.StateCode !== 0) {
                if (res.data.StateCode == 99) {
                    this.$router.push('/login')
                } else {
                    this.$notify({
                        title: '错误',
                        message: res.data.StateMsg,
                        type: 'error'
                    });
                }
            } else {
                this.roleControlForm.allData = res.data.Data
            }
        })
    }

}


// WEBPACK FOOTER //
// ./src/pages/acountManage/RoleControl.js